import React, { useReducer, useContext, useEffect, useCallback } from 'react';
import { IGetModifierPortionInfo, TLanguageIDs } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getModifierPortionInfo } from 'backend/modifiers';
import { IAppContext, AppContext } from 'appState/appContext';
import { viewPortionInitialState, ViewPortionContext } from './viewPortionContext';
import { viewPortionReducer } from './viewPortionReducer';
import { ViewPortionActionTypes } from './viewPortionActions';
import { IViewModifierContext, ViewModifierContext } from '../../../../viewModifierState/viewModifierContext';

export const ViewPortionState = ({ children }: JSX.ElementChildrenAttribute) => {
	const [state, dispatch] = useReducer(viewPortionReducer, viewPortionInitialState);
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { selectedPortionId } = useContext<IViewModifierContext>(ViewModifierContext);
	const { response, loading } = useFetchData<IGetModifierPortionInfo, string>(
		selectedPortionId.length ? getModifierPortionInfo : null,
		selectedPortionId,
	);

	useEffect(() => {
		loading ? showLoader() : hideLoader();
	}, [loading]);

	useEffect(() => {
		if (response) {
			dispatch({
				type: ViewPortionActionTypes.SET_DATA,
				payload: {
					portionFullInfo: response.data,
				},
			});
		}
	}, [response]);

	const setTranslationTab = useCallback((value: Nullable<TLanguageIDs>) => {
		dispatch({
			type: ViewPortionActionTypes.SET_TRANSLATION_TAB,
			payload: {
				selectedTranslationTab: value,
			},
		});
	}, []);

	return (
		<ViewPortionContext.Provider
			value={{
				setTranslationTab,
				portionFullInfo: state.portionFullInfo,
				selectedTranslationTab: state.selectedTranslationTab,
			}}>
			{children}
		</ViewPortionContext.Provider>
	);
};
